import Icon from 'components/shared/Icon/Icon';

const TermsCard = ({ title, subtitle, children }) => {
  const icon = title === 'Myriad Health' ? 'myriad-health-illustration' : 'medi-pay-illustration';
  
  return (
    <div className="grid grid-cols-[auto_1fr] gap-4 rounded-2xl border border-solid border-neutral-200 bg-neutral-50 p-6">
      <div className="flex-shrink-0">
        <Icon icon={icon} />
      </div>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <span className="text-base font-600">{title}</span>
          <p className="text-sm font-400 text-neutral-600">{subtitle}</p>
        </div>
        {children}
      </div>
    </div>
  );
};

export default TermsCard;
